import type { ComponentType } from 'react';

type TPageModule = {
  default: ComponentType;
};

type TLazyPage = {
  Component: () => Promise<ComponentType>;
};

const toLazyPage = (load: () => Promise<TPageModule>): TLazyPage => ({ Component: () => load().then(module => module.default) });

export type {
  TLazyPage,
  TPageModule,
};
export {
  toLazyPage,
};
